/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_55c7fc88"]'><div :class='["dialog-btn-vertical-passenger-demo"]'><cube-button @_click="onClickDialog">Dialog - vertical btns</cube-button><cube-dialog ref="__mpx_ref_dialogWithVerticalBtns__"><div slot="title" :class='["dialog-vertical-btns-title"]'>测试标题</div><div slot="content" :class='["dialog-btn-content"]'>测试content</div><div slot="btns" :class='["dialog-btn-slot-vertical"]'><div @tap='(e)=>__invoke(e, [["onCloseDialog"]])' :class='["lead-btn"]'>引导文案</div><div @tap='(e)=>__invoke(e, [["onCloseDialog"]])' :class='["lead-btn"]'>按钮文案</div><div @tap='(e)=>__invoke(e, [["onCloseDialog"]])' :class='["lead-btn"]'>按钮文案</div></div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_55c7fc88"}'>
@require "@mpxjs/mpx-cube-ui/src/common/stylus/variable.styl"
@require "@mpxjs/mpx-cube-ui/src/common/stylus/mixin.styl"

.dialog-vertical-btns-title
  margin-top 24px
  font-size 20px
.dialog-btn-content
  text-align center
  font-size 14px
.dialog-btn-slot-vertical
  .lead-btn
    border-top-1px($var(border-color-normal))
    height 23px
    padding 13.5px 0 14px
    font-size 16px
    text-align center
    line-height 23px
    color #444
    &:first-child
      color #EA5E1E
    &:last-child
      height 22px
      line-height 22px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_55c7fc88"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_55c7fc88"}
  /** script content **/
  require("./dialog-btn-vertical.mpx.js?isComponent&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-btn-vertical.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_55c7fc88"],
    ctorType: "component",
    outputPath: "components/dialog-btn-vertical55c7fc88/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>